<template>
  <simpleSalesScreen :outsideTypeSale="'Pedido'" />
</template>

<script>
import simpleSalesScreen from "../../components/GeneralSalesScreen/simpleSalesScreen.vue";
export default {
  components: {
    simpleSalesScreen,
  },
};
</script>